export default "__VITE_ASSET__Cukzl4bb__"